<template>
  <a-modal
    v-model:open="visible"
    title="隱私權政策及會員服務條款"
    :width="850"
    :maskClosable="false"
    :closable="false"
    class="legal-policy-modal"
  >
    <div class="modal-content" ref="modalContentRef" @scroll="handleScroll">
      <div class="policy-content">
        <PrivacyAndTermsDocument />
      </div>
    </div>

    <template #footer>
      <div class="modal-footer-container">
        <div class="checkbox-container">
          <a-checkbox v-model:checked="isChecked">
            我已詳細閱讀並同意上述「隱私權政策及會員服務條款」之全部內容
          </a-checkbox>
        </div>
        <div class="button-group">
          <a-button @click="handleCancel">取消</a-button>
          <a-button type="primary" @click="handleAgree" :disabled="!isChecked"> 我同意 </a-button>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script setup>
import { ref, watch, nextTick } from "vue";
import { message } from "ant-design-vue";
import PrivacyAndTermsDocument from "./PrivacyAndTermsDocument.vue";

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
  courseId: {
    type: [String, Number],
    default: null,
  },
  examId: {
    type: [String, Number],
    default: null,
  },
});

const emit = defineEmits(["update:open", "agree", "cancel"]);

const visible = ref(false);
const isChecked = ref(false);
const modalContentRef = ref(null);

watch(
  () => props.open,
  (newVal) => {
    visible.value = newVal;
    if (newVal) {
      isChecked.value = false;
      nextTick(() => {
        if (modalContentRef.value) {
          modalContentRef.value.scrollTop = 0;
        }
      });
    }
  }
);

watch(visible, (newVal) => {
  emit("update:open", newVal);
});

const handleScroll = () => {
  // Optional scroll listener
};

const handleAgree = () => {
  if (!isChecked.value) {
    message.warning("請先勾選同意條款");
    return;
  }
  emit("agree");
  visible.value = false;
};

const handleCancel = () => {
  emit("cancel");
  visible.value = false;
};
</script>

<style scoped>
.modal-content {
  max-height: 65vh;
  overflow-y: auto;
  padding: 16px 20px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  scrollbar-width: thin;
  scrollbar-color: #94a3b8 #f1f5f9;
}

.modal-content::-webkit-scrollbar {
  width: 8px;
}

.modal-content::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.modal-content::-webkit-scrollbar-thumb {
  background: #94a3b8;
  border-radius: 4px;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background: #64748b;
}

.policy-content {
  line-height: 1.7;
}

.modal-footer-container {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 10px 0 4px 0;
}

.checkbox-container {
  display: flex;
  justify-content: flex-start;
  font-size: 14px;
}

.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
